import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-diceIcons-D12',
    templateUrl: './D12.svg',
    styleUrls: ['./diceIcons-D12.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiceIconsD12Component { }
